import {
  study_identification,
  study_oversight,
  contact_information,
  study_outcome_measures,
  study_timeline,
  study_scope,
  study_reference,
  study_description,
  study_eligibilty,
  study_ipd,
  study_arms,
  ctis_form,
  member_states_concerned,
} from "./fieldSchemas"

import { studyDetailsDataSchema } from "./studyDetailsDataSchema"

import { eupasProperties } from "./eupasDataSchema"
import { STUDY_TYPES } from "../enum/enum"

import { jrctDataSchema, jrctTypeOfResearchDependencies } from "./jrctDataSchema"

// let studyDetailsSchemaWithoutMilestones = { ...studyDetailsDataSchema }
// delete studyDetailsSchemaWithoutMilestones.milestone_dates

export const primeProtocolDataSchema = {
  type: "object",
  properties: {
    protocol: {
      type: "object",
      properties: {
        protocol_id: {
          title: "Protocol ID",
          type: "string",
        },
        study_type: {
          type: "string",
          title: "Study Type",
          default: "Interventional",
          enum: [],
          options: STUDY_TYPES,
        },
        ...studyDetailsDataSchema,
      },
      dependencies: {
        study_type: {
          oneOf: [
            {
              properties: {
                study_type: {
                  enum: ["Interventional"],
                  options: STUDY_TYPES,
                },
                // eudract_number: {
                //   type: "string",
                // },
                type_of_research: jrctDataSchema.type_of_research,
                study_identification,
                ctis_form,
                mscs: member_states_concerned,
                contact_information: contact_information.interventional_observational,
                study_oversight: study_oversight.interventional,
                study_timeline: study_timeline.interventional_observational,
                study_description: study_description,
                study_scope: study_scope.interventional,
                study_arms: study_arms.interventional,
                study_eligibilty: study_eligibilty.interventional,
                study_ipd: study_ipd.interventional_observational,
                study_outcome_measures: study_outcome_measures.interventional_observational,
                study_reference: study_reference.interventional,
                investigator_information: jrctDataSchema.investigator_information,
                information_on_multicenter_clinical_trials: jrctDataSchema.information_on_multicenter_clinical_trials,
                overview_of_pharmaceuticals: jrctDataSchema.overview_of_pharmaceuticals,
                monetary_sponsor: jrctDataSchema.monetary_sponsor,
                irb_information: jrctDataSchema.irb_information,
                milestone_dates: studyDetailsDataSchema.milestone_dates,
                ema_hma_additional_information: eupasProperties.ema_hma_additional_information,
              },
              dependencies: {
                type_of_research: {
                  oneOf: [
                    {
                      properties: {
                        type_of_research: {
                          type: "string",
                          enum: ["Clinical Trials, Post Marketing Surveillance"],
                        },
                        ...jrctTypeOfResearchDependencies.int.post_marketing,
                      },
                    },
                    {
                      properties: {
                        type_of_research: {
                          type: "string",
                          enum: ["Other Clinical Research"],
                        },
                        ...jrctTypeOfResearchDependencies.int.other_research,
                      },
                    },
                  ],
                },
              },
            },
            {
              properties: {
                study_type: {
                  type: "string",
                  enum: ["Observational"],
                  options: STUDY_TYPES,
                },
                type_of_research: jrctDataSchema.type_of_research,
                study_identification,
                ctis_form,
                mscs: member_states_concerned,
                contact_information: contact_information.interventional_observational,
                study_oversight: study_oversight.observational,
                study_timeline: study_timeline.interventional_observational,
                study_description: study_description,
                study_scope: study_scope.observational,
                study_arms: study_arms.observational,
                study_eligibilty: study_eligibilty.observational,
                study_ipd: study_ipd.interventional_observational,
                study_outcome_measures: study_outcome_measures.interventional_observational,
                study_reference: study_reference.observational,
                investigator_information: jrctDataSchema.investigator_information,
                information_on_multicenter_clinical_trials: jrctDataSchema.information_on_multicenter_clinical_trials,
                overview_of_pharmaceuticals: jrctDataSchema.overview_of_pharmaceuticals,
                monetary_sponsor: jrctDataSchema.monetary_sponsor,
                irb_information: jrctDataSchema.irb_information,
                milestone_dates: studyDetailsDataSchema.milestone_dates,
                ema_hma_additional_information: eupasProperties.ema_hma_additional_information,
              },
              dependencies: {
                type_of_research: {
                  oneOf: [
                    {
                      properties: {
                        type_of_research: {
                          type: "string",
                          enum: ["Clinical Trials, Post Marketing Surveillance"],
                        },
                        ...jrctTypeOfResearchDependencies.obs.post_marketing,
                      },
                    },
                    {
                      properties: {
                        type_of_research: {
                          type: "string",
                          enum: ["Other Clinical Research"],
                        },
                        ...jrctTypeOfResearchDependencies.obs.other_research,
                      },
                    },
                  ],
                },
              },
            },
            {
              properties: {
                study_type: {
                  type: "string",
                  enum: ["Expanded Access"],
                  options: STUDY_TYPES,
                },
                type_of_research: jrctDataSchema.type_of_research,
                study_identification,
                ctis_form,
                mscs: member_states_concerned,
                contact_information: contact_information.expanded_access,
                study_oversight: study_oversight.expanded_access,
                study_timeline: study_timeline.expanded_access,
                study_description: study_description,
                study_scope: study_scope.expanded_access,
                study_arms: study_arms.expanded_access,
                study_eligibilty: study_eligibilty.expanded_access,
                study_outcome_measures: study_outcome_measures.expanded_access,
                study_reference: study_reference.expanded_access,
                investigator_information: jrctDataSchema.investigator_information,
                information_on_multicenter_clinical_trials: jrctDataSchema.information_on_multicenter_clinical_trials,
                overview_of_pharmaceuticals: jrctDataSchema.overview_of_pharmaceuticals,
                monetary_sponsor: jrctDataSchema.monetary_sponsor,
                irb_information: jrctDataSchema.irb_information,
                ema_hma_additional_information: eupasProperties.ema_hma_additional_information,
              },
              dependencies: {
                type_of_research: {
                  oneOf: [
                    {
                      properties: {
                        type_of_research: {
                          type: "string",
                          enum: ["Clinical Trials, Post Marketing Surveillance"],
                        },
                        ...jrctTypeOfResearchDependencies.expanded.post_marketing,
                      },
                    },
                    {
                      properties: {
                        type_of_research: {
                          type: "string",
                          enum: ["Other Clinical Research"],
                        },
                        ...jrctTypeOfResearchDependencies.expanded.other_research,
                      },
                    },
                  ],
                },
              },
            },
          ],
        },
      },
    },
  },
}
